<div class="Dialog" mat-dialog-content>
  <div>
    <p>Are you sure you want to reset all selections?</p>
  </div>
  <mat-dialog-actions>
    <button mat-button [mat-dialog-close]="true">Yes, Reset</button>
    <button mat-button [mat-dialog-close]="false" cdkFocusInitial>No, Keep My Selections</button>
  </mat-dialog-actions>
</div>